module.exports = __webpack_public_path__ + "static/media/contact-bg.cdb9bcb4.png";